/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import { errorMessageWrapperStyles, newTitleBoxIconStyles, titleBoxFooterStyles, titleBoxHeaderStyles, titleBoxIconStyles, titleBoxWrapperStyles } from './styles';
export var TitleBoxWrapper = function TitleBoxWrapper(props) {
  var breakpoint = props.breakpoint,
    titleBoxBgColor = props.titleBoxBgColor,
    hidden = props.hidden;
  return jsx("div", {
    id: "titleBoxWrapper",
    "data-testid": "media-title-box"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: titleBoxWrapperStyles({
      breakpoint: breakpoint,
      display: hidden ? 'none' : 'flex',
      titleBoxBgColor: titleBoxBgColor
    })
  }, props.children);
};
export var TitleBoxHeader = function TitleBoxHeader(props) {
  var hasIconOverlap = props.hasIconOverlap;
  return jsx("div", {
    id: "titleBoxHeader",
    "data-testid": "title-box-header"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: titleBoxHeaderStyles({
      hasIconOverlap: hasIconOverlap
    })
  }, props.children);
};
export var TitleBoxFooter = function TitleBoxFooter(props) {
  var hasIconOverlap = props.hasIconOverlap;
  return jsx("div", {
    id: "titleBoxFooter",
    "data-testid": "title-box-footer"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: titleBoxFooterStyles({
      hasIconOverlap: hasIconOverlap
    })
  }, props.children);
};
export var TitleBoxIcon = function TitleBoxIcon(props) {
  return jsx("div", {
    id: "titleBoxIcon",
    "data-testid": "title-box-icon",
    css: fg('platform-visual-refresh-icons') ?
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    newTitleBoxIconStyles :
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    titleBoxIconStyles
  }, props.children);
};
export var ErrorMessageWrapper = function ErrorMessageWrapper(props) {
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  return jsx("div", {
    css: errorMessageWrapperStyles
  }, props.children);
};